export default __webpack_public_path__ + "static/media/location_grey.f1b56580.svg";